<template>
    <div>
        <div class="container py-5 my-0 my-sm-5 px-4">
            <div class="row mb-2 border-bottom">
                <div class="col-12 d-flex justify-content-between p-4">
                            <b-col cols="6" class="text-left">
                                <div class="logo-wrapper">
                                    <img src="../../../../assets/img/bau-logo-for-light.svg" alt="Logo" style="max-height: 40px;"/>
                                </div>
                            </b-col>
<!--                            <b-col cols="4" class="text-center d-none d-md-block">-->
<!--                                <h4>{{ $t('toles_application_form').toUpper() }}</h4>-->
<!--                            </b-col>-->
                            <b-col cols="6" class="text-right">

                                <b-dropdown variant="link" no-caret right>
                                    <template #button-content>
                                        <b-avatar :text="sortName" :size="50"  badge-offset="-6px"  variant="primary">
<!--                                            <template #badge>-->
<!--                                                <i class="ri-arrow-drop-down-line font-size-20"></i>-->
<!--                                            </template>-->
                                        </b-avatar>
                                    </template>
                                    <b-dropdown-item-button @click="logout" class="d-flex justify-content-between">
                                        <i class="ri-user-3-fill mr-2"></i>
                                        <span style="font-size: 14px">
                                            {{userName}}
                                        </span>
                                    </b-dropdown-item-button>

                                    <b-dropdown-item-button @click="logout">
                                        <i class="ri-logout-box-r-line mr-2"></i> {{ $t('logout') }}
                                    </b-dropdown-item-button>
                                </b-dropdown>
                            </b-col>

                </div>
            </div>
                <b-alert variant="success" :show="user.payment_status==='E' || successPaymentValue">
                    <h4 class="alert-heading">Sayın {{user.name.toLocaleUpperCase('tr-TR')}} {{user.surname.toLocaleUpperCase('tr-TR')}}</h4>
                    <span>
                   </span>  {{toLocaleDateTime(user.payment_date)}} Tarihinde Başvurunuz başarıyla tamamlanmıştır.
                </b-alert>
            <b-card class="mb-2" :title="$t('toles_application_form').toUpper()">
                <ApplicationForm @successPayment="successPayment"/>
            </b-card>
        </div>
    </div>
</template>
<script>

import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import ApplicationForm from  "@/modules/tolesApplication/pages/student/ApplicationForm.vue"
export default {
    components: {
        ApplicationForm,
        ProcessingButton,
    },
    metaInfo() {
        return {
            title: this.$t('toles_application_form'),
        }
    },

    data(){
        return {
            successPaymentValue:false,

            user:{
                university_id:null,
                student_status:null,
                faculty:null,
                program:null,
                application_type:null,
                application_detail:null,
                payment_status:null,
            },
            loading:false,
            form:{
                name:null,
            }
        }
    },
    computed:{
      userName(){
          const name=this.user.name??null
          const surname =this.user.surname??null

          if (!name || typeof name !== 'string' || name.length === 0) {
              return "";
          }
          return name.charAt(0).toLocaleUpperCase('tr-TR') + name.slice(1) + ' ' + surname.charAt(0).toLocaleUpperCase('tr-TR') + surname.slice(1)
      },
        sortName(){
            const name=this.user.name??null
            const surname =this.user.surname??null
            if (!name || typeof name !== 'string' || name.length === 0) {
                return "";
            }
            return name.charAt(0).toLocaleUpperCase('tr-TR') + '.' + surname.charAt(0).toLocaleUpperCase('tr-TR')
        }
    },
    created() {
        this.user =localStorage.getItem('toles_application_user')?JSON.parse(localStorage.getItem('toles_application_user')):null;
        const pin =localStorage.getItem('pin')?JSON.parse(localStorage.getItem('pin')):null
        if (!this.user  || !this.user.name || !this.user.surname || !this.user.national_id || !pin){
            this.$router.push('/toles/application/login')
            return
        }
    },

    methods:{
        logout(){
            this.$store.dispatch('TolesApplicationStore/logout')
            localStorage.removeItem('sessionExpiryTime');
            this.$router.push('/toles/application/login')
        },
        successPayment(){
         this.successPaymentValue=true
        },
    }

};
</script>
<style>
.rowClass {
    cursor: all-scroll;
}
</style>

